// boton general - funcionamiento

import { Button } from '@mui/material';

export default function GButton({
  children,
  onClick,
  variant = 'primary',
  sx = {}
}) {
  const baseStyles = {
    textTransform: 'none',
    borderRadius: '3px',
    padding: '6px 12px',
    margin: '2px',
    transition: '0.2s',
    fontSize: '13px',
  };

  const variants = {
    primary: {
      border: 'none',
      padding: '5px',
      backgroundColor: '#0A2647',
      color: '#415A77',
      '&:hover': { backgroundColor: '#144272' }
    },
    clearBlue: {
      border: 'none',
      backgroundColor: "#3f74b1",
      color: "#fff",
      padding: '4px 8px',
      fontSize: '12px',
      textTransform: 'uppercase',
      '&:hover': { backgroundColor: '#415A77' }, 
    },
    secondary: {
      border: 'none',
      padding: '5px',
      cursor: 'pointer',
      borderRadius: '3px',
      color: '#fff',
      backgroundColor: '#0A2647',
      '&:hover': { backgroundColor: '#415A77' }
    },
    navButton: {
      display: 'block',
      width: '100%',
      padding: '8px',
      margin: '10px 0',
      backgroundColor: '#144272',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      textAlign: 'left',
      '&:hover': { backgroundColor: '#1B263B' }
    },
    navSubMenuButton: {
      display: 'block',
      width: '100%',
      padding: '5px',
      margin: '4px 0',
      backgroundColor: '#415A77',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      textAlign: 'left',
      fontSize: '13px',
      '&:hover': { backgroundColor: '#1B263B' }
    }
  };

  return (
    <Button
      onClick={onClick}
      sx={{
        ...baseStyles,
        ...variants[variant],
        ...sx
      }}
    >
      {children}
    </Button>
  );
}